import { logNotification } from './OTelNotifications';
var NAMESPACE_SEPARATOR = '.';
var tenantTokens = {};
export function setTenantTokens(namespace, telemetryProperties) {
    if (
    // Starts with "Office." and doesn't end with "."
    namespace.substring(0, 7) === 'Office' + NAMESPACE_SEPARATOR &&
        namespace[namespace.length - 1] !== NAMESPACE_SEPARATOR) {
        if (tenantTokens[namespace]) {
            if (telemetryProperties.ariaTenantToken) {
                tenantTokens[namespace].ariaTenantToken = telemetryProperties.ariaTenantToken;
            }
            if (telemetryProperties.dnmToken) {
                tenantTokens[namespace].dnmToken = telemetryProperties.dnmToken;
            }
        }
        else {
            tenantTokens[namespace] = telemetryProperties;
        }
    }
    else {
        logNotification(0 /* LogLevel.Error */, 0 /* Category.Core */, function () {
            return "Namespace: ".concat(namespace);
        });
        return;
    }
}
/**
 * Gets the tenant tokens corresponding to an event
 * Strategy: Search for the whole string, then substrings that could be the namespace
 * @param eventName - The event name
 * @returns - The corresponding tenant tokens, or undefined if none found
 */
export function fillTenantTokens(eventName, telemetryProperties) {
    var indexOfCharacterAfterNamespace = eventName.length;
    while (indexOfCharacterAfterNamespace > 0) {
        var namespaceCandidate = eventName.substr(0, indexOfCharacterAfterNamespace);
        if (tenantTokens[namespaceCandidate]) {
            var storedTelemetryProperties = tenantTokens[namespaceCandidate];
            telemetryProperties.ariaTenantToken = storedTelemetryProperties.ariaTenantToken;
            telemetryProperties.dnmToken = storedTelemetryProperties.dnmToken;
            return true;
        }
        indexOfCharacterAfterNamespace = eventName.lastIndexOf(NAMESPACE_SEPARATOR, indexOfCharacterAfterNamespace - 1);
    }
    return false;
}
export function clear() {
    tenantTokens = {};
}
//# sourceMappingURL=TenantTokenManager.js.map